export const PUBLISHER_ABILITY = [
    { subject: "publisher-overview", action: "manage" },
    { subject: "publisher-earnings", action: "manage" },
    { subject: "publisher-contracts", action: "manage" },
    { subject: "publisher-kyc", action: "manage" },
    { subject: "publisher-guide", action: "manage" }
];
